<template>
    <rkm-modal
        :buttons="['cancel']"
        ref="RkmModal"
        title="Últimos atendimentos"
        large
    >
        <List :data="data" />
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

export default {
    components: { List },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>